
export const themeSliderSettings = {
    slidesPerView: 'auto',
    a11y: {
        firstSlideMessage: 'Dies ist die erste Folie',
        lastSlideMessage: 'Dies ist die letzte Folie',
        nextSlideMessage: 'nächste Folie',
        prevSlideMessage: 'vorherige Folie',
    },
    freeMode: {
        enabled: true,
        sticky: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        600: {
            slidesPerView: 2,
        },
        760: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 3,
        },
    },
};